import React, { lazy, Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import LoginPage from "./pages/LoginPage";
import SchimbaParolaPage from "./pages/SchimbaParolaPage";
import DashboardPage from "./pages/DashboardPage";
import AngajatiPage from "./pages/AngajatiPage";
import SetariPage from "./pages/SetariPage";
import PlaceholderPage from "./pages/PlaceholderPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
const LeaduriPage = lazy(() => import("./pages/LeaduriPage"));
const ActivitatiPage = lazy(() => import("./pages/ActivitatiPage"));
const ClientiPage = lazy(() => import("./pages/ClientiPage"));
const ClientFisaPage = lazy(() => import("./pages/ClientFisaPage"));
const ProiectePage = lazy(() => import("./pages/ProiectePage"));
const ProiecteInLucruPage = lazy(() => import("./pages/ProiecteInLucruPage"));
const ProiectInLucruPage = lazy(() => import("./pages/ProiectInLucruPage"));
const ProiectEtapePage = lazy(() => import("./pages/ProiectEtapePage"));
const ProiectFisaPage = lazy(() => import("./pages/ProiectFisaPage"));
const RaportarePage = lazy(() => import("./pages/RaportarePage"));
const SeoProiectePage = lazy(() => import("./pages/SeoProiectePage"));
const SeoCalendarPage = lazy(() => import("./pages/SeoCalendarPage"));
const SeoRapoarteAziPage = lazy(() => import("./pages/SeoRapoarteAziPage"));
const FinantePage = lazy(() => import("./pages/FinantePage"));
const HomePageOne = lazy(() => import("./pages/HomePageOne"));
const HomePageTwo = lazy(() => import("./pages/HomePageTwo"));
const HomePageThree = lazy(() => import("./pages/HomePageThree"));
const HomePageFour = lazy(() => import("./pages/HomePageFour"));
const HomePageFive = lazy(() => import("./pages/HomePageFive"));
const HomePageSix = lazy(() => import("./pages/HomePageSix"));
const HomePageSeven = lazy(() => import("./pages/HomePageSeven"));
const EmailPage = lazy(() => import("./pages/EmailPage"));
const AddUserPage = lazy(() => import("./pages/AddUserPage"));
const AlertPage = lazy(() => import("./pages/AlertPage"));
const AssignRolePage = lazy(() => import("./pages/AssignRolePage"));
const AvatarPage = lazy(() => import("./pages/AvatarPage"));
const BadgesPage = lazy(() => import("./pages/BadgesPage"));
const ButtonPage = lazy(() => import("./pages/ButtonPage"));
const CalendarMainPage = lazy(() => import("./pages/CalendarMainPage"));
const CardPage = lazy(() => import("./pages/CardPage"));
const CarouselPage = lazy(() => import("./pages/CarouselPage"));
const ChatEmptyPage = lazy(() => import("./pages/ChatEmptyPage"));
const ChatMessagePage = lazy(() => import("./pages/ChatMessagePage"));
const ChatProfilePage = lazy(() => import("./pages/ChatProfilePage"));
const CodeGeneratorNewPage = lazy(() => import("./pages/CodeGeneratorNewPage"));
const CodeGeneratorPage = lazy(() => import("./pages/CodeGeneratorPage"));
const ColorsPage = lazy(() => import("./pages/ColorsPage"));
const ColumnChartPage = lazy(() => import("./pages/ColumnChartPage"));
const CompanyPage = lazy(() => import("./pages/CompanyPage"));
const CurrenciesPage = lazy(() => import("./pages/CurrenciesPage"));
const DropdownPage = lazy(() => import("./pages/DropdownPage"));
const ErrorPage = lazy(() => import("./pages/ErrorPage"));
const FaqPage = lazy(() => import("./pages/FaqPage"));
const ForgotPasswordPage = lazy(() => import("./pages/ForgotPasswordPage"));
const FormLayoutPage = lazy(() => import("./pages/FormLayoutPage"));
const FormValidationPage = lazy(() => import("./pages/FormValidationPage"));
const FormPage = lazy(() => import("./pages/FormPage"));
const GalleryPage = lazy(() => import("./pages/GalleryPage"));
const ImageGeneratorPage = lazy(() => import("./pages/ImageGeneratorPage"));
const ImageUploadPage = lazy(() => import("./pages/ImageUploadPage"));
const InvoiceAddPage = lazy(() => import("./pages/InvoiceAddPage"));
const InvoiceEditPage = lazy(() => import("./pages/InvoiceEditPage"));
const InvoiceListPage = lazy(() => import("./pages/InvoiceListPage"));
const InvoicePreviewPage = lazy(() => import("./pages/InvoicePreviewPage"));
const KanbanPage = lazy(() => import("./pages/KanbanPage"));
const LanguagePage = lazy(() => import("./pages/LanguagePage"));
const LineChartPage = lazy(() => import("./pages/LineChartPage"));
const ListPage = lazy(() => import("./pages/ListPage"));
const MarketplaceDetailsPage = lazy(() => import("./pages/MarketplaceDetailsPage"));
const MarketplacePage = lazy(() => import("./pages/MarketplacePage"));
const NotificationAlertPage = lazy(() => import("./pages/NotificationAlertPage"));
const NotificationPage = lazy(() => import("./pages/NotificationPage"));
const PaginationPage = lazy(() => import("./pages/PaginationPage"));
const PaymentGatewayPage = lazy(() => import("./pages/PaymentGatewayPage"));
const PieChartPage = lazy(() => import("./pages/PieChartPage"));
const PortfolioPage = lazy(() => import("./pages/PortfolioPage"));
const PricingPage = lazy(() => import("./pages/PricingPage"));
const ProgressPage = lazy(() => import("./pages/ProgressPage"));
const RadioPage = lazy(() => import("./pages/RadioPage"));
const RoleAccessPage = lazy(() => import("./pages/RoleAccessPage"));
const SignInPage = lazy(() => import("./pages/SignInPage"));
const SignUpPage = lazy(() => import("./pages/SignUpPage"));
const StarRatingPage = lazy(() => import("./pages/StarRatingPage"));
const StarredPage = lazy(() => import("./pages/StarredPage"));
const SwitchPage = lazy(() => import("./pages/SwitchPage"));
const TableBasicPage = lazy(() => import("./pages/TableBasicPage"));
const TableDataPage = lazy(() => import("./pages/TableDataPage"));
const TabsPage = lazy(() => import("./pages/TabsPage"));
const TagsPage = lazy(() => import("./pages/TagsPage"));
const TermsConditionPage = lazy(() => import("./pages/TermsConditionPage"));
const TextGeneratorPage = lazy(() => import("./pages/TextGeneratorPage"));
const ThemePage = lazy(() => import("./pages/ThemePage"));
const TooltipPage = lazy(() => import("./pages/TooltipPage"));
const TypographyPage = lazy(() => import("./pages/TypographyPage"));
const UsersGridPage = lazy(() => import("./pages/UsersGridPage"));
const UsersListPage = lazy(() => import("./pages/UsersListPage"));
const ViewDetailsPage = lazy(() => import("./pages/ViewDetailsPage"));
const VideoGeneratorPage = lazy(() => import("./pages/VideoGeneratorPage"));
const VideosPage = lazy(() => import("./pages/VideosPage"));
const ViewProfilePage = lazy(() => import("./pages/ViewProfilePage"));
const VoiceGeneratorPage = lazy(() => import("./pages/VoiceGeneratorPage"));
const WalletPage = lazy(() => import("./pages/WalletPage"));
const WidgetsPage = lazy(() => import("./pages/WidgetsPage"));
const WizardPage = lazy(() => import("./pages/WizardPage"));
const TextGeneratorNewPage = lazy(() => import("./pages/TextGeneratorNewPage"));


function App() {
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <AuthProvider>
      <Suspense fallback={<div className="text-center py-64"><div className="spinner-border text-primary-600" role="status"><span className="visually-hidden">Se încarcă…</span></div></div>}>
      <Routes>
        {/* === CRM iCode === */}
        <Route exact path="/login" element={<LoginPage />} />
        <Route exact path="/schimba-parola" element={<SchimbaParolaPage />} />
        <Route exact path="/" element={<Navigate to="/dashboard" replace />} />
        <Route exact path="/dashboard" element={
          <ProtectedRoute perm="dashboard.read"><DashboardPage /></ProtectedRoute>
        } />
        <Route exact path="/angajati" element={
          <ProtectedRoute perm="users.read"><AngajatiPage /></ProtectedRoute>
        } />
        <Route exact path="/setari" element={
          <ProtectedRoute perm="settings.read"><SetariPage /></ProtectedRoute>
        } />
        {/* Module planificate în etapele 2–9 */}
        <Route exact path="/leaduri" element={
          <ProtectedRoute perm="lead.read"><LeaduriPage /></ProtectedRoute>
        } />
        <Route exact path="/activitati" element={
          <ProtectedRoute perm="lead.read"><ActivitatiPage /></ProtectedRoute>
        } />
        <Route exact path="/clienti" element={
          <ProtectedRoute perms={["client.read", "client.read.assigned"]}><ClientiPage /></ProtectedRoute>
        } />
        <Route exact path="/clienti/:id" element={
          <ProtectedRoute perms={["client.read", "client.read.assigned"]}><ClientFisaPage /></ProtectedRoute>
        } />
        <Route exact path="/proiecte" element={
          <ProtectedRoute perms={["project.read", "project.read.assigned"]}><ProiectePage /></ProtectedRoute>
        } />
        <Route exact path="/proiecte-in-lucru" element={
          <ProtectedRoute perms={["project.read", "project.read.assigned"]}><ProiecteInLucruPage /></ProtectedRoute>
        } />
        <Route exact path="/proiecte-in-lucru/:id" element={
          <ProtectedRoute perms={["project.read", "project.read.assigned"]}><ProiectInLucruPage /></ProtectedRoute>
        } />
        <Route exact path="/proiecte/:id" element={
          <ProtectedRoute perms={["project.read", "project.read.assigned"]}><ProiectFisaPage /></ProtectedRoute>
        } />
        <Route exact path="/proiecte/:id/etape" element={
          <ProtectedRoute perms={["project.read", "project.read.assigned"]}><ProiectEtapePage /></ProtectedRoute>
        } />
        <Route exact path="/raportare" element={
          <ProtectedRoute perms={["report.read", "report.own"]}><RaportarePage /></ProtectedRoute>
        } />
        <Route exact path="/seo/proiecte" element={
          <ProtectedRoute perms={["seo.read", "seo.read.assigned"]}><SeoProiectePage /></ProtectedRoute>
        } />
        <Route exact path="/seo/calendar" element={
          <ProtectedRoute perms={["seo.read", "seo.read.assigned"]}><SeoCalendarPage /></ProtectedRoute>
        } />
        <Route exact path="/seo/rapoarte-azi" element={
          <ProtectedRoute perms={["seo.read", "seo.read.assigned"]}><SeoRapoarteAziPage /></ProtectedRoute>
        } />
        <Route exact path="/finante/situatie" element={
          <ProtectedRoute perm="finance.read"><FinantePage sectiune="situatie" /></ProtectedRoute>
        } />
        <Route exact path="/finante/management" element={
          <ProtectedRoute perm="finance.read"><FinantePage sectiune="management" /></ProtectedRoute>
        } />
        <Route exact path="/finante/tranzactii" element={
          <ProtectedRoute perm="finance.read"><FinantePage sectiune="tranzactii" /></ProtectedRoute>
        } />
        <Route exact path="/finante/incasari" element={
          <ProtectedRoute perm="finance.read"><FinantePage sectiune="incasari" /></ProtectedRoute>
        } />
        <Route exact path="/finante/cheltuieli" element={
          <ProtectedRoute perm="finance.read"><FinantePage sectiune="cheltuieli" /></ProtectedRoute>
        } />
        <Route exact path="/finante/planificare" element={
          <ProtectedRoute perm="finance.read"><FinantePage sectiune="planificare" /></ProtectedRoute>
        } />
        <Route exact path="/finante/cheltuieli-fixe" element={
          <ProtectedRoute perm="finance.read"><FinantePage sectiune="cheltuieli-fixe" /></ProtectedRoute>
        } />
        <Route exact path="/finante/conturi" element={
          <ProtectedRoute perm="finance.read"><FinantePage sectiune="conturi" /></ProtectedRoute>
        } />
        <Route exact path="/finante/analiza" element={
          <ProtectedRoute perm="finance.read"><FinantePage sectiune="analiza" /></ProtectedRoute>
        } />

        {/* === Pagini demo template (neatinse, păstrate ca referință) === */}
        <Route exact path="/demo/index" element={<HomePageOne />} />
        <Route exact path="/index-2" element={<HomePageTwo />} />
        <Route exact path="/index-3" element={<HomePageThree />} />
        <Route exact path="/index-4" element={<HomePageFour />} />
        <Route exact path="/index-5" element={<HomePageFive />} />
        <Route exact path="/index-6" element={<HomePageSix />} />
        <Route exact path="/index-7" element={<HomePageSeven />} />


        {/* SL */}
        <Route exact path="/add-user" element={<AddUserPage />} />
        <Route exact path="/alert" element={<AlertPage />} />
        <Route exact path="/assign-role" element={<AssignRolePage />} />
        <Route exact path="/avatar" element={<AvatarPage />} />
        <Route exact path="/badges" element={<BadgesPage />} />
        <Route exact path="/button" element={<ButtonPage />} />
        <Route exact path="/calendar-main" element={<CalendarMainPage />} />
        <Route exact path="/calendar" element={<CalendarMainPage />} />
        <Route exact path="/card" element={<CardPage />} />
        <Route exact path="/carousel" element={<CarouselPage />} />
        <Route exact path="/chat-empty" element={<ChatEmptyPage />} />
        <Route exact path="/chat-message" element={<ChatMessagePage />} />
        <Route exact path="/chat-profile" element={<ChatProfilePage />} />
        <Route exact path="/code-generator" element={<CodeGeneratorPage />} />
        <Route exact path="/code-generator-new" element={<CodeGeneratorNewPage />} />
        <Route exact path="/colors" element={<ColorsPage />} />
        <Route exact path="/column-chart" element={<ColumnChartPage />} />
        <Route exact path="/company" element={<CompanyPage />} />
        <Route exact path="/currencies" element={<CurrenciesPage />} />
        <Route exact path="/dropdown" element={<DropdownPage />} />
        <Route exact path="/email" element={<EmailPage />} />
        <Route exact path="/faq" element={<FaqPage />} />
        <Route exact path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route exact path="/form-layout" element={<FormLayoutPage />} />
        <Route exact path="/form-validation" element={<FormValidationPage />} />
        <Route exact path="/form" element={<FormPage />} />
        <Route exact path="/gallery" element={<GalleryPage />} />
        <Route exact path="/image-generator" element={<ImageGeneratorPage />} />
        <Route exact path="/image-upload" element={<ImageUploadPage />} />
        <Route exact path="/invoice-add" element={<InvoiceAddPage />} />
        <Route exact path="/invoice-edit" element={<InvoiceEditPage />} />
        <Route exact path="/invoice-list" element={<InvoiceListPage />} />
        <Route exact path="/invoice-preview" element={<InvoicePreviewPage />} />
        <Route exact path="/kanban" element={<KanbanPage />} />
        <Route exact path="/language" element={<LanguagePage />} />
        <Route exact path="/line-chart" element={<LineChartPage />} />
        <Route exact path="/list" element={<ListPage />} />
        <Route exact path="/marketplace-details" element={<MarketplaceDetailsPage />} />
        <Route exact path="/marketplace" element={<MarketplacePage />} />
        <Route exact path="/notification-alert" element={<NotificationAlertPage />} />
        <Route exact path="/notification" element={<NotificationPage />} />
        <Route exact path="/pagination" element={<PaginationPage />} />
        <Route exact path="/payment-gateway" element={<PaymentGatewayPage />} />
        <Route exact path="/pie-chart" element={<PieChartPage />} />
        <Route exact path="/portfolio" element={<PortfolioPage />} />
        <Route exact path="/pricing" element={<PricingPage />} />
        <Route exact path="/progress" element={<ProgressPage />} />
        <Route exact path="/radio" element={<RadioPage />} />
        <Route exact path="/role-access" element={<RoleAccessPage />} />
        <Route exact path="/sign-in" element={<SignInPage />} />
        <Route exact path="/sign-up" element={<SignUpPage />} />
        <Route exact path="/star-rating" element={<StarRatingPage />} />
        <Route exact path="/starred" element={<StarredPage />} />
        <Route exact path="/switch" element={<SwitchPage />} />
        <Route exact path="/table-basic" element={<TableBasicPage />} />
        <Route exact path="/table-data" element={<TableDataPage />} />
        <Route exact path="/tabs" element={<TabsPage />} />
        <Route exact path="/tags" element={<TagsPage />} />
        <Route exact path="/terms-condition" element={<TermsConditionPage />} />
        <Route exact path="/text-generator-new" element={<TextGeneratorNewPage />} />
        <Route exact path="/text-generator" element={<TextGeneratorPage />} />
        <Route exact path="/theme" element={<ThemePage />} />
        <Route exact path="/tooltip" element={<TooltipPage />} />
        <Route exact path="/typography" element={<TypographyPage />} />
        <Route exact path="/users-grid" element={<UsersGridPage />} />
        <Route exact path="/users-list" element={<UsersListPage />} />
        <Route exact path="/view-details" element={<ViewDetailsPage />} />
        <Route exact path="/video-generator" element={<VideoGeneratorPage />} />
        <Route exact path="/videos" element={<VideosPage />} />
        <Route exact path="/view-profile" element={<ViewProfilePage />} />
        <Route exact path="/voice-generator" element={<VoiceGeneratorPage />} />
        <Route exact path="/wallet" element={<WalletPage />} />
        <Route exact path="/widgets" element={<WidgetsPage />} />
        <Route exact path="/wizard" element={<WizardPage />} />


        <Route exact path="*" element={<ErrorPage />} />


      </Routes>
      </Suspense>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;



